import { render } from "./FenixAlliance.vue?vue&type=template&id=c58fe3ae&scoped=true"
import script from "./FenixAlliance.vue?vue&type=script&lang=js"
export * from "./FenixAlliance.vue?vue&type=script&lang=js"

import "./FenixAlliance.vue?vue&type=style&index=0&id=c58fe3ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c58fe3ae"]])

export default __exports__